<ng-container *ngIf="isDefectDetailsView; else defaultViewer">
  <div class="defect-image-viewer">
    <div class="defect-image-viewer__meta">
      <div class="defect-image-viewer__meta-text">
        <div class="defect-image-viewer__author">{{ 'label.author' | loc }}: {{ data?.authorName || '-' }}</div>
        <div class="defect-image-viewer__name">{{ currentImage?.fileName || '' }}</div>
      </div>

      <button
        mat-stroked-button
        type="button"
        class="defect-image-viewer__download"
        [disabled]="downloading || !currentImage?.download || currentImage?.download?.location !== FileLocation.DEFECTS"
        (click)="download()"
      >
        <mat-icon>download</mat-icon>
        {{ 'button.save' | loc }}
      </button>
    </div>

    <div class="defect-image-viewer__image">
      <ng-content *ngTemplateOutlet="img"></ng-content>
    </div>

    <button mat-flat-button color="primary" type="button" class="defect-image-viewer__close" [mat-dialog-close]="false">
      {{ 'button.close' | loc }}
    </button>
  </div>
</ng-container>

<ng-template #defaultViewer>
  <div class="default-image-viewer">

    <div class="default-image-viewer__content">
      <ng-content *ngTemplateOutlet="img"></ng-content>
    </div>

    <div class="default-image-viewer__buttons">
      <app-icon-button icon="clear" [stroke]="true" [fliko]="true" color="primary" [mat-dialog-close]="false">
        {{ 'button.close' | loc }}</app-icon-button
      >
      <app-icon-button icon="download" [stroke]="true" [fliko]="true" [inverse]="true" color="primary" (click)="download()">{{
        'button.save' | loc
      }}</app-icon-button>
    </div>
  </div>
</ng-template>

<ng-template #img>
  <img [src]="currentImage?.rawData" *ngIf="currentImage?.rawData; else fromPath" />
  <ng-template #fromPath><img [src]="currentImage?.path ?? '' | getStorageURL" /></ng-template>
</ng-template>
